
// Vue
import { Component, Vue, Prop, Watch, Emit } from "vue-property-decorator";
import { namespace, Getter, Mutation, Action } from "vuex-class";

// Types
import { ITaskDynamicDataTypes, ISyncEntry, ISyncType, ISyncSystem, IQuerySync, SyncTypes } from "@/store/sync/types";
import { GroupWithPermissions } from "@/store/areas/types";
import {
	UserManagementState,
	UserDetails,
	UserRole,
	UserRolePermission,
	Permission,
} from "@/store/user-management/types";
import { ExternalMapLayer } from "@/store/external-map-layers/types";

// Third Party
import moment from "moment";
import { validationMixin } from "vuelidate";
import { required, requiredIf, minLength, maxLength, numeric } from "vuelidate/lib/validators";
import { isEqual, debounce } from "lodash";
import { formatDateMixin } from "@/mixins.ts";

// Components
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import vSelect from "vue-select";
import AreaSelect from "@/components/form/AreaSelect.vue";
import SureViewIcon from "@/components/SureViewIcon.vue";
import { externalMapLayers } from "@/store/external-map-layers";

// Namespaces
const ExternalMapLayerStore = namespace("externalMapLayers");

@Component({
	mixins: [validationMixin],
	validations: {},
	components: {
		"v-select": vSelect,
		"vue-perfect-scrollbar": VuePerfectScrollbar,
	},
})
export default class DeleteExternalMapLayerModal extends Vue {
	@Prop({ default: null, type: Object }) selectedMapLayer: ExternalMapLayer;
	@Prop({ default: false, type: Boolean }) visible: boolean;

	@ExternalMapLayerStore.Action deleteExternalMapLayer: (externalMapLayerID: number) => Promise<void>;

	@Emit("toggle-modal")
	@Emit("delete-external-map-layer")
	private closeModal() {}

	private async removeExternalMapLayer() {
		await this.deleteExternalMapLayer(this.selectedMapLayer.externalMapLayerID);
		this.closeModal();
		this.$emit("toggle-modal");
		this.$emit("delete-successful");
	}
}
